import { useCallback, useState } from "react";
import useOrderCheckoutApi from "@apis/useOrderCheckoutApi";

/**
 * 取得訂單抵用劵折扣資料
 */
const useOrderCampaignDiscount = () => {
	const { postOrdersCheckoutCampaignApi } = useOrderCheckoutApi();

	// 折扣結果
	const [campaignResult, setCampaignResult] = useState(null);

	/**
	 * 依照目前參數取得折扣結果
	 * @param {Object} params - getParams() 以及 campaignID
	 */
	const fetchCampaignDiscount = useCallback(
		async params => {
			if (!params?.campaignID) {
				setCampaignResult(null);
				return null;
			}
			try {
				const resp = await postOrdersCheckoutCampaignApi({
					receiverType: params.receiverType || 0,
					receiverID: params.receiverID || 0,
					clubID: params.clubID || 0,
					receiverName: params.receiverName || "",
					receiverPhone: params.receiverPhone || "",
					employeeID: params.employeeID || 0,
					orderDate: params.orderDate,
					checkoutOrderIDs: params.checkoutOrderIDs || [],
					items: params.items || [],
					products: params.products || [],
					deviceOrderItems: params.deviceOrderItems || [],
					purchaseTimeType: params.purchaseTimeType || 0,
					purchaseToolType: params.purchaseToolType || 0,
					cashPayment: params.cashPayment || 0,
					cardPayment: params.cardPayment || 0,
					walletPayment: params.walletPayment || 0,
					invoiceSetting: {
						issuingType: params.issuingType || 0,
						invoiceCarrierType: params.invoiceCarrierType || 0,
						invoiceCarrierNo: params.invoiceCarrierNo || "",
						taxTitle: params.taxTitle || "",
						taxID: params.taxID || "",
						donationCode: params.donationCode || "",
						invoiceNo: params.invoiceNo || "",
						issuingEmail: params.issuingEmail || "",
					},
					campaignID: params.campaignID || 0,
				});
				setCampaignResult(resp);
				return resp;
			} catch (error) {
				// 捕捉後端錯誤，避免呼叫端畫面壞掉
				setCampaignResult(null);
				console.error("fetchCampaignDiscount error:", error);
			}
		},
		// eslint-disable-next-line
		[postOrdersCheckoutCampaignApi],
	);

	/**
	 * 清除折扣結果
	 */
	const clearCampaignResult = useCallback(() => {
		setCampaignResult(null);
	}, []);

	return { campaignResult, fetchCampaignDiscount, clearCampaignResult };
};

export default useOrderCampaignDiscount;
